import { render, staticRenderFns } from "./BalanceBlock.vue?vue&type=template&id=cffd0ad0&scoped=true"
import script from "./BalanceBlock.vue?vue&type=script&lang=js"
export * from "./BalanceBlock.vue?vue&type=script&lang=js"
import style0 from "./BalanceBlock.vue?vue&type=style&index=0&id=cffd0ad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffd0ad0",
  null
  
)

export default component.exports